<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.12</b> - Caverns performance & fixes</p>
    <div class="ml-5 pb-4 text-green-400">
      <div class="font-bold mt-2">Gameplay & Balance Changes</div>
      <ul class="ml-4 list-disc">
        <li>Nerfed Flying Jellies</li>
        <li>
          Players who maintain maximum tier (10) in Inn Tournaments now receive upgrade rewards
        </li>
        <li>
          Caverns rooms now generate with at least 20 additional tiles beyond the number of players'
          units
        </li>
      </ul>

      <div class="font-bold mt-2">AI</div>
      <ul class="ml-4 list-disc">
        <li>Improved decision-making for AoE abilities to avoid harming allies</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed Caverns Battle Log not processing events when browser tab was hidden</li>
        <li>Fixed XP potion tooltip timer display</li>
        <li>Fixed scrolling issues in Battle Log Modal and Inn Logs Modal</li>
      </ul>

      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>Inn battle logs now indicate whether battles were attacks or defenses</li>
        <li>Active XP potion tooltips now show time remaining instead of total duration</li>
        <li>Caverns Battle Log now stops when party is defeated</li>
      </ul>
    </div>
  </div>
</template>
